/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResponseData } from './responseData';
import { AuthenticationExtensionsClientOutputs } from './authenticationExtensionsClientOutputs';
import { PublicKeyCredentialType } from './publicKeyCredentialType';


export interface AuthenticatorAttestationRawResponse { 
    id?: string | null;
    rawId?: string | null;
    type?: PublicKeyCredentialType;
    response?: ResponseData;
    extensions?: AuthenticationExtensionsClientOutputs;
}

